module.exports = {
  email: 'sadityakumar9211@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/sadityakumar9211',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/saditya9211',
    },
    {
      name: 'Hashnode',
      url: 'https://saditya9211.hashnode.dev',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/saditya9211',
    },
    {
      name: 'Stackoverflow',
      url: 'https://stackoverflow.com/users/14769639/saditya',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#ff2200',
    navy: '#f6f1f1',
    darkNavy: '#ffffff',
    // white: "ffffff",
    // red: "#ff2200",
    // whiteGray: "#f6f1f1 ",
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
